import React from "react"
import config from "../lib/config"
import * as styles from "./by-a-student.module.css"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const founder = {
  name: "Gabriel Romualdo",
  gradYear: 23,
  school: "Boston University Academy",
}

export default function Example(props) {
  return (
    <section
      className={`${props.bgClassName || "bg-gray-100"} overflow-hidden pt-10`}
      id="about"
    >
      <div className="relative max-w-7xl mx-auto pt-20 pb-12 px-4 sm:px-6 lg:px-8 lg:py-20">
        <svg
          className="absolute top-full left-0 transform translate-x-80 -translate-y-24 lg:hidden"
          width={784}
          height={404}
          fill="none"
          viewBox="0 0 784 404"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width={784}
            height={404}
            fill="url(#e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32)"
          />
        </svg>

        <svg
          className="hidden lg:block absolute right-full top-1/2 transform translate-x-1/2 -translate-y-1/2"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="56409614-3d62-4985-9a10-7ca758a8f4f0"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={784}
            fill="url(#56409614-3d62-4985-9a10-7ca758a8f4f0)"
          />
        </svg>

        <div className="relative lg:flex">
          <div className="hidden lg:block lg:flex-shrink-0">
            <StaticImage
              src="../images/founder.png"
              alt={founder.name}
              placeholder="blurred"
              width={450}
              height={450}
              className="h-64 w-64 rounded-full xl:h-80 xl:w-80"
            />
          </div>

          <div className="relative lg:ml-10">
            <svg
              className="absolute top-0 left-0 transform -translate-x-8 -translate-y-24 h-36 w-36 text-indigo-200 opacity-50"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 144 144"
              aria-hidden="true"
            >
              <path
                strokeWidth={2}
                d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
              />
            </svg>
            <blockquote className="relative">
              <div className="lg:hidden w-full flex justify-center">
                <StaticImage
                  src="../images/founder.png"
                  alt={founder.name}
                  placeholder="blurred"
                  width={450}
                  height={450}
                  className="block w-56 max-w-full rounded-full mb-8"
                />
              </div>
              <h1 className="text-4xl leading-9 font-bold text-gray-900 mb-6">
                {props.headerText ||
                  "Built by a student, with students in mind"}
              </h1>
              <h1 className="text-2xl leading-7 font-medium text-gray-600 mb-6">
                Hi, I'm Gabriel, the founder of {config.siteTitle}.
              </h1>
              <div
                className={`text-lg leading-8 text-gray-600 ${styles.textBlock}`}
              >
                {/* <p>
                  I created {config.siteTitle} because of a problem in the way
                  that most schools respond to emergencies.
                </p>
                <p>
                  A school's emergency response process typically involves
                  faculty members meticulously counting students, checking off
                  attendance sheets, and liaising with other faculty members
                  about attendance until finally ending the emergency and
                  allowing students back into the building.
                </p>
                <p>
                  This process can be slow, tedious, and it can be distracting
                  from what really matters &mdash; making sure every student is
                  safe, and helping students that are in danger. I've seen
                  emergency response situations like these in schools on
                  countless occasions; I'm a high school student myself so I see
                  this several times per year.
                </p>
                <p>
                  Coming from a technical background with the experience
                  necessary to develop such a platform, I created{" "}
                  {config.siteTitle} to streamline the emergency response
                  process for schools and help keep students more safe.
                </p>
                <p>
                  <strong>{config.siteTitle} is built for schools.</strong> It's
                  affordable, it's easy to set up, and it has many features
                  built specifically for educational institutions, along with
                  the tools you'd expect from a typical digital emergency
                  response platform.
                </p>
                <p>
                  I built this system from the ground up, and I'll be here to
                  help with any technical problems you face, take feedback, and
                  create the features that you want most.
                </p>
                <p>
                  And don't worry: I come from the technical background that's
                  necessary to maintain this product. I've been writing software
                  for 7 years, working with companies like{" "}
                  <a href="https://geeksforgeeks.com/" className="styled-link">
                    GeeksforGeeks
                  </a>{" "}
                  and contributing to open source projects like PyTorch, and I'm
                  currently a software engineer at{" "}
                  <a href="https://speechify.com/" className="styled-link">
                    Speechify
                  </a>
                  .
                </p>
                <p>I hope to hear from you soon!</p> */}
                {props.headerText ? (
                  <>
                    <p>
                      {config.siteTitle} started as a project within the{" "}
                      <Link
                        to="https://buacsclub.vercel.app"
                        className="styled-link"
                      >
                        Boston University Academy Computer Science Club
                      </Link>
                      , of which I am one of the club leaders. A school
                      administrator reached out to us wanting to see if we could
                      come up with a more effective digital solution to respond
                      to emergencies and take attendance. The school's existing
                      system could send automated text messages and emails, but
                      it wasn't able to take attendance live or allow faculty to
                      monitor the emergency and contact students in danger.
                    </p>

                    <p>
                      After a couple months of working with the school and
                      writing the code behind an initial version of the app, a
                      working prototype was finished, with a live roll call,
                      automated alerts, and preset emergency scenarios.
                      Eventually, deploying the project at Boston University
                      Academy didn't work out because of logistical issues, and
                      the code and the rest of the project was left with me.
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      I'm a sophomore at Boston University Academy looking to
                      make a positive impact on schools with code.{" "}
                      {config.siteTitle} started as a project within the{" "}
                      <Link
                        to="https://buacsclub.vercel.app"
                        className="styled-link"
                      >
                        Boston University Academy Computer Science Club
                      </Link>
                      , of which I am one of the club leaders. After logistical
                      issues caused the project to be paused at Boston
                      University Academy, I decided that working with other
                      schools on the project would be an optimal direction to
                      take it.
                    </p>
                    <p>
                      A school's emergency response process typically involves
                      faculty members meticulously counting students, checking
                      off attendance sheets, and liaising with other faculty
                      members about attendance until finally ending the
                      emergency and allowing students back into the building.
                    </p>
                    <p>
                      This process can be slow, tedious, and it can be
                      distracting from what really matters &mdash; making sure
                      every student is safe, and helping students that are in
                      danger. I've seen emergency response situations like these
                      in schools on countless occasions; I'm a high school
                      student myself so I see this several times per year.
                    </p>
                    <p>
                      {config.siteTitle} streamlines emergency response and
                      helps keep students more safe.{" "}
                      <strong>
                        And {config.siteTitle} is built for schools.
                      </strong>{" "}
                      It's affordable, it's easy to set up, and it has many
                      features built specifically for educational institutions,
                      along with the tools you'd expect from a typical digital
                      emergency response platform.
                    </p>
                    <p>
                      In the past couple of months, I've been busy building some
                      of the key features of {config.siteTitle} and making it
                      more reliable, easy to use, and fast.
                    </p>
                  </>
                )}

                <hr style={{ marginTop: "2rem", marginBottom: "2rem" }} />

                <p>
                  Right now, we're looking to learn more from schools about what
                  they think could be most beneficial in an emergency response
                  app like {config.siteTitle}.
                </p>

                <p>
                  And as the product takes shape, we're looking for schools that
                  want to try out the app and help us make the improvements
                  needed to help keep schools and students more safe.
                </p>

                <p>
                  We'd love to hear from you &mdash; contact us at{" "}
                  <a
                    className="styled-link"
                    href="mailto:gabriel@gabrielromualdo.com"
                  >
                    gabriel@gabrielromualdo.com
                  </a>{" "}
                  or feel free to{" "}
                  <Link className="styled-link" to="/request-a-demo">
                    schedule a call
                  </Link>{" "}
                  with us to discuss.
                </p>
              </div>
              <footer className="mt-8">
                <div className="flex">
                  <div className="flex-shrink-0 lg:hidden">
                    <StaticImage
                      src="../images/founder.png"
                      alt={founder.name}
                      placeholder="blurred"
                      width={450}
                      height={450}
                      className="h-12 w-12 rounded-full"
                    />
                  </div>
                  <div className="ml-4 lg:ml-0">
                    <div className="text-base font-medium text-gray-900">
                      {founder.name}
                    </div>
                    <div className="text-base font-medium text-default-600">
                      Founder, {config.siteTitle}
                    </div>
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  )
}
